import FileSaver from 'file-saver';
import { escapeCsvField } from './escape-csv-field';

export function saveToCsv(content: (string | number)[][], filename: string) {
    const csvData = content.map((row) => row.map(escapeCsvField).join(',')).join('\n');
    const bom = '\uFEFF';
    const blob = new Blob([bom + csvData], {
        type: 'text/csv;charset=utf-8',
    });

    FileSaver.saveAs(blob, filename);
}
